import React, { Component, Fragment } from 'react';
import { Col, Row, Container } from 'reactstrap';

import Helmet from 'react-helmet';

import Css from '@components/ExperiencesLandingPage/ExperiencesLandingPage.scss';
import Disclaimer from '@components/Experiences/Disclaimer/Disclaimer';
import Data from './exclusive-data';
import Tile from './Tile/Tile';
import NextSteps from '@components/Experiences/NextSteps/NextSteps';
import ImportImages from '@src/importImages';

const Brunel = ImportImages('/experiences/Exclusive/brunel.jpg');

class ExclusiveExperience extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    let Tiles = [];
    Data.forEach((cur, ind) => {
      Tiles.push(<Tile {...cur} key={ind} index={ind + 1} />);
    });

    return (
      <Fragment>
        <Helmet>
          <title>JetSuite Exclusive Experiences</title>
          <meta name="description" content={'JetSuite Exclusive Experiences'} />
        </Helmet>
        <div
          className={'pt-5 pb-5 ' + Css['background-box']}
          style={{
            backgroundImage: 'url(' + Brunel + ')',
            backgroundSize: '100% auto'
          }}
        >
          <Container>
            <Row>
              <Col className={'pt-5 pb-4'}>
                <div className={'mt-5 mb-5 p-4 background-transblack'}>
                  <h1 className={Css.header}>JetSuite Exclusive Experiences</h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Panel */}
        <Container>{Tiles}</Container>

        {/* Next Steps */}
        <NextSteps
          pageWidth={this.props.pageWidth}
          location={'exclusive'}
          eventName={'Exclusive Experiences Join Button Clicks'}
          hideBtn={true}
        />

        <Disclaimer className={'pb-5 pt-3 px-3 font-xs text-justify'} />
      </Fragment>
    );
  }
}
export default ExclusiveExperience;



// WEBPACK FOOTER //
// ./src/components/ExclusiveExperience/ExclusiveExperience.js